export function fadeEdgeSlides(swiper) {
  if (!swiper?.el || !swiper.slides) return;

  const parent = swiper.el.getBoundingClientRect();

  swiper.slides.forEach((slide) => {
    const rect = slide.getBoundingClientRect();
    const hiddenRight = Math.max(0, rect.right - parent.right);
    const hiddenLeft = Math.max(0, parent.left - rect.left);
    const hidden = Math.max(hiddenRight, hiddenLeft);
    const ratio = rect.width ? hidden / rect.width : 0;

    if (ratio > 0.05) {
      const opacity = Math.min(1, Math.max(0.5, 1 - ratio * 0.45));
      slide.style.opacity = opacity.toFixed(2);
      slide.style.filter = "saturate(0.85)";
    } else {
      slide.style.opacity = "1";
      slide.style.filter = "none";
    }
  });
}
